import Big from 'big.js';
import Util from '../lib/util.js';

const DeliveryFns = {
  /**
   * 生产出货产品项次ID，用于前端去重
   *
   * 订单出货：类型 + 订单号 + 项次号 + 分批序号 生成id做为唯一性判断，后台id在不同接口中无法保持一致。
   * 排程出货：类型 + 产品编码 + 订单号 + 项次号 + 出货日期 生成id做为唯一性判断。
   * 按退货出：类型 + 出货单 + 出货项次
   */
  genDeliveryItemId(item) {
    if (item.billType === 1) {
      //订单出货
      return '1' + item.poXkNo + item.poLineNo + item.subLineNo;
    } else if (item.billType === 2) {
      //排程出货
      return (
        '2' +
        item.productCode +
        item.poXkNo +
        item.poLineNo +
        item.vExpectedDate
      );
    } else {
      //按退货单
      return '3' + item.rtoXkNo + item.rtoLineNo;
    }
  },

  //组装扩展字段
  addExtendFields(item) {
    //组装扩展字段
    let extendFields: any[] = [];
    if (item.poLine && !Util.isEmpty(item.poLine.fieldsShow)) {
      let obj = JSON.parse(item.poLine.fieldsShow);
      for (let key in obj) {
        extendFields.push({
          key: obj[key],
          value: item.poLine[key]
        });
      }
    }
    item.extendFields = extendFields;
  },

  //重组列表，相同订单项次合并在一起
  parseLineList(sublist) {
    let obj = {};
    let arr: any[] = [];
    sublist.forEach(item => {
      // if ( item.billType === 1 ) {  //订单出货
      //   item.lineId = '1' + item.poXkNo + item.poLineNo;  //类型 + 订单号 + 项次号
      // } else {  //排程出货
      //   item.lineId = '2' + item.productCode + item.poXkNo + item.poLineNo;  //类型 + 产品编码 + 订单号 + 订单项次
      // }
      item.lineId = item.productCode + item.poXkNo + item.poLineNo; // 产品编码 + 订单号 + 订单项次
      if (item.billType === 3) {
        item.lineId = item.productCode + item.rtoXkNo + item.rtoLineNo; // 产品编码 + 退货单号 + 退货单项次
      }
      if (obj[item.lineId] === undefined) {
        obj[item.lineId] = [item];
      } else {
        obj[item.lineId].push(item);
      }
      Util.genExtendFields(item.poLine);
    });
    for (let key in obj) {
      let line = obj[key];
      line.lineNos = line.map(m => m.lineNo).join('_'); //用于条码打印时传参
      this.figureLineSummary(line);
      arr.push(obj[key]);
    }
    return arr;
  },

  //汇总分批答交或排程
  figureLineSummary(line) {
    let i = Big(0),
      j = Big(0),
      k = Big(0),
      m = Big(0),
      n = Big(0),
      o = Big(0),
      w = Big(0),
      x = Big(0);
    line.forEach(item => {
      //统计分批答交数量
      i = i.plus(item.waitDeliveryQty || 0);
      j = j.plus(item.deliveryQty || 0);
      k = k.plus(item.receiveQty || 0);
      m = m.plus(item.storageQty || 0);
      n = n.plus(item.returnQty || 0);
      o = o.plus(item.deliveryValuationQty || 0);
      w = w.plus(item.applyDeliveryQty || 0);
      x = x.plus(item.applyDeliveryValuationQty || 0);
    });
    line.waitDeliveryQty = parseFloat(i); //按排程出货或分批答交时需要前端累加总可出货量
    line.deliveryQty = parseFloat(j);
    line.receiveQty = parseFloat(k);
    line.storageQty = parseFloat(m);
    line.returnQty = parseFloat(n);
    line.deliveryValuationQty = parseFloat(o);
    line.totalWaitDeliveryQty =
      line[0].billType === 1
        ? line[0].totalWaitDeliveryQty
        : line.waitDeliveryQty; //总待出量
    //是否单行显示：分批项只有一项且总待出量等于待出量。包含1.无分批答交。2.有分批答交且仅选一项分批且未出量等于总未出量。
    //line.isSingle = line.length === 1 && (line[0].totalWaitDeliveryQty === line[0].waitDeliveryQty);
    line.isSingle = line.length === 1;
    line.applyDeliveryQty = parseFloat(w); //送货申请单数量
    line.applyDeliveryValuationQty = parseFloat(x); //送货申请单计价数量
  },

  //计算出货异常，未出货，收货差异
  figureDiff(lineList) {
    let i = 0; //出货异常统计（按明细）
    let j = 0; //收货未匹配（按明细）
    let k = 0; //收货差异（按项次）
    lineList.forEach(line => {
      line.forEach(item => {
        if (item.waitDeliveryQty !== item.deliveryQty) {
          i += 1;
        }
        if (item.receiveQty === 0) {
          j += 1;
        }
      });
      if (line.receiveQty !== 0 && line.receiveQty !== line.deliveryQty) {
        k += 1;
      }
    });
    return [i, j, k];
  },

  //条码明细列表
  parseBarcodeList(response, lineList) {
    let list: any[] = [];
    let obj = {};
    if (Array.isArray(response.data)) {
      //根据出货列表组装条码列表
      if (Array.isArray(lineList)) {
        lineList.forEach(line => {
          let lineId = line[0].lineId;
          if (obj[lineId] === undefined) {
            let prod: any = { list: [] };
            prod.line = [line[0]];
            prod.line.deliveryQty = line.deliveryQty;
            prod.productCode = line[0].productCode;
            prod.productName = line[0].productName;
            prod.productScale = line[0].productScale;
            prod.poErpNo = line[0].poErpNo;
            prod.poLineNo = line[0].poLineNo;

            if (prod.dnLineNos === undefined) {
              //旧数据未生成条码包含项次
              prod.dnLineNos = line.map(m => m.lineNo).join('_');
            }

            obj[lineId] = prod;
          }
        });
      }
      response.data.forEach(item => {
        let lineId = item.productCode + item.poXkNo + item.poLineNo; //产品编码 + 订单号 + 订单项次
        if (typeof item.hiddenCodeJson === 'string') {
          try {
            let hiddenCode = JSON.parse(item.hiddenCodeJson);
            item.arrHiddenCode = Object.keys(hiddenCode).map(key => {
              let o = hiddenCode[key];
              return o.text + ': ' + o.value;
            });
          } catch (e) {
            //todo
          }
        }
        if (obj[lineId] === undefined) {
          obj[lineId] = { list: [item] };
        } else {
          obj[lineId].list.push(item);
        }
      });
      for (let lineId in obj) {
        let prod = obj[lineId];
        let qty = 0;
        let bigCode: any[] = [];
        let outerCode: any[] = [];
        prod.list.forEach((item, i) => {
          qty += item.smallIncludeCount;
          if (
            item.bigBarcode !== null &&
            bigCode.indexOf(item.bigBarcode) === -1
          ) {
            bigCode.push(item.bigBarcode);
          }
          if (
            item.outerBarcode !== null &&
            outerCode.indexOf(item.outerBarcode) === -1
          ) {
            outerCode.push(item.outerBarcode);
          }
          if (i === 0 || item.bigBarcode !== prod.list[i - 1].bigBarcode) {
            item.isShowBig = true;
          }
          if (i === 0 || item.outerBarcode !== prod.list[i - 1].outerBarcode) {
            item.isShowOuter = true;
          }
        });
        prod.lineId = lineId;

        // prod.productCode = prod.list[0].productCode;
        // prod.productName = prod.list[0].productName;
        // prod.productScale = prod.list[0].productScale;
        // prod.poErpNo = prod.list[0].poErpNo;
        // prod.poLineNo = prod.list[0].poLineNo;

        prod.qty = qty;
        prod.bigCode = bigCode;
        prod.outerCode = outerCode;
        prod.isExpand = true; //默认展开

        list.push(prod);

        //标记是否已产生条码标签
        if (Array.isArray(lineList)) {
          lineList.forEach(line => {
            if (line[0].lineId === lineId && qty > 0) {
              line.hasBarcode = true;
            }
          });
        }
      }
    }
    return list;
  },

  //计算交料通知确认后答交列表未出货数量
  caculateReplyQty(item, list, listIndex) {
    let total = 0;
    list?.forEach(line => (total += Number(line.noticeQty)));
    let qty = total;
    let date = item.noticeExpectedDate;
    let replyList = item.answerLineList;

    if (Array.isArray(replyList)) {
      let length = replyList.length;
      let index = replyList.map(reply => reply.vExpectedDate).indexOf(date);
      //清空数据以便重新计算

      replyList.forEach(reply => {
        reply.vQty = undefined;
        reply.vWaitDeliveryQty =
          reply.vPurchaseQty - reply.totalCfmSubDeliveryQty;
      });

      replyList.forEach(reply => {
        let m = reply.vWaitDeliveryQty;
        let n = 0;
        if (reply.vQty !== undefined) {
          return;
        }
        if ([1].includes(reply.answerFrom)) {
          reply.vQty = m;
          return;
        }
        if (qty === 0) {
          reply.vQty = m;
          return;
        }
        if (qty <= m) {
          n = m - qty;
          qty = 0;
        } else {
          n = 0;
          qty -= m;
        }
        reply.vQty = n;
      });
    }
    list
      ?.filter((line, i) => i !== 0)
      .forEach(line => {
        line.answerLineList = list[listIndex || 0].answerLineList;
      });
  }
};

export default DeliveryFns;
